import { render, staticRenderFns } from "./souvenir.vue?vue&type=template&id=434b0e8e&scoped=true&"
import script from "./souvenir.vue?vue&type=script&lang=js&"
export * from "./souvenir.vue?vue&type=script&lang=js&"
import style0 from "./souvenir.vue?vue&type=style&index=0&id=434b0e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434b0e8e",
  null
  
)

export default component.exports